import React, { useState, useRef } from "react";
import { materials } from "../materialsData";
import "../css/materialsSearchBar.scss";
import CancelIcon from "@mui/icons-material/Cancel";

const MaterialsSearchBar = ({ addMaterial }) => {
  const [results, setResults] = useState([]);
  const searchRef = useRef(null);

  const clearResults = () => {
    searchRef.current.value = "";
    setResults([]);
  };

  const lookupMaterials = (e) => {
    let value = e.target.value;

    if (value.trim().length === 0) {
      setResults([]);
      return;
    }

    let results = materials.filter((mat) =>
      mat.materialDescription.toLowerCase().includes(value.toLowerCase())
    );

    setResults(results);
  };

  return (
    <div className="materialsSearchBar">
      <div className="materialsSearchInput">
        <input
          ref={searchRef}
          type="text"
          onChange={lookupMaterials}
          placeholder="search"
        />
        <button onClick={clearResults}>
          <CancelIcon />
        </button>
      </div>

      <div className="materialsSearchResults">
        {results
          .map((mat) => {
            return (
              <button
                className="materialsResultSearchLine"
                onClick={() => {
                  addMaterial(mat);
                  clearResults();
                }}
                key={mat.materialCode}
              >
                <span>{mat.materialDescription}</span>
                <span>£{mat.itemRefPrice}</span>
              </button>
            );
          })
          .filter((x, i) => i < 15)}
      </div>
    </div>
  );
};

export default MaterialsSearchBar;
